import { gateway } from "../../../../gateway";
import { InstalledAppVersionsData, InstalledAppVersionsResponse } from "../types";

export interface IGetInstalledAppVersionsQueryParams {
  page?: number;
  pageSize?: number;
  targetType?: string;
  appPlatform?: string;
  status?: string;
}

export const getInstalledAppVersionsAction = async (
  queryParams: IGetInstalledAppVersionsQueryParams = {}
): Promise<InstalledAppVersionsData | null> => {
  const token = sessionStorage.getItem("token");

  const response = await gateway.get<InstalledAppVersionsResponse>("/app-version/installed", {
    params: queryParams,
    headers: {
      Authorization: `${token}`,
    },
  });

  if (response?.data?.data) {
    return response.data.data;
  }
  return null;
};
